import { FC } from "react";

import { BindingProps } from "./Binding";

const PopupBinding: FC<BindingProps> = function ({ nativeBinding }) {
  return null;
};

export default PopupBinding;
